import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

import useYardActionEvents from "@hsl/core/hooks/useYardAnalyticsEvents";
import useFCSubscriptionStore from "@hsl/fc-subscription/store";
import { type User } from "@hsl/fc-subscription/types";

import { Translate } from "../../../../../hooks/useTranslation";
import Button from "../../../../Button";
import Spinner from "../../../../Spinner";
import { useSubscriptionContext } from "../../../Root";
import TimingSelector from "../../../SubscriptionFlows/Steps/SelectDocuments/TimingSelector";

interface Props {
    user: User;
}

export const WeeklyRoundupEmailTimings = ({ user }: Props) => {
    const { dropdownEvent } = useYardActionEvents();
    const updateUser = useFCSubscriptionStore((state) => state.updateUser);
    const [dayOfWeek, setDayOfWeek] = useState<
        typeof user.dayOfWeek | undefined
    >(user.dayOfWeek);
    const {
        config: { locale },
    } = useSubscriptionContext();

    const save = useMutation({
        mutationFn: async () => {
            await updateUser({ dayOfWeek });
        },
    });

    return (
        <div className="mt-8">
            <p className="my-6">
                <Translate>
                    You can adjust the day on which you receive your weekly
                    round up
                </Translate>
                .
            </p>
            <div className="flex w-max max-w-full flex-col items-end gap-8">
                <TimingSelector
                    onChange={(dayOfWeek) => {
                        setDayOfWeek(dayOfWeek);
                        dropdownEvent({
                            name: "Edit weekly day",
                            value: dayOfWeek as string,
                            position: "Timing of roundup emails",
                        });
                    }}
                    locale={locale.replace("_", "-")}
                    dayOfWeek={dayOfWeek}
                    hideAdditionalText
                    className="w-full max-w-3xl grid-cols-1 md:grid-cols-3"
                />
                <Button
                    className="flex-row-reverse"
                    variant="large"
                    onClick={() => save.mutate()}
                    disabled={save.isLoading || dayOfWeek === user.dayOfWeek}
                    icon={
                        save.isLoading ? (
                            <Spinner className="my-0 ml-4 mr-0 h-4 w-4 animate-spin" />
                        ) : undefined
                    }
                >
                    <Translate>Save</Translate>
                </Button>
            </div>
        </div>
    );
};
